import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import "bootstrap/dist/css/bootstrap.min.css";
import "./fonts.css";
import "./theme.scss";
import App from "./App";
import { store } from "./store/store";
import useIsMobile from "./hooks/useIsMobile";

// On phones, toasts behave like the mobile app's snackbars: bottom of the screen,
// just above the tab bar (64px + safe area) instead of covering the top app bar.
function AppToaster() {
	const isMobile = useIsMobile();
	return (
		<Toaster
			position={isMobile ? "bottom-center" : "top-right"}
			containerStyle={isMobile ? { bottom: "calc(76px + env(safe-area-inset-bottom))" } : undefined}
			toastOptions={{ duration: 3500 }}
		/>
	);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<AppToaster />
			<App />
		</Provider>
	</React.StrictMode>
);
